import { auth } from '@/firebase'
import { signOut as firebaseSignOut } from 'firebase/auth'
// src/lib/authFirebase.js
// Firestore-only auth shim to match the old API surface.

import {
  verifyFirestoreCredentials,
  ensureMirrorUserDocByEmailLower,
} from '@/services/firestore/usersService'

function notify() { try { window.dispatchEvent(new Event('sessionchange')) } catch {} }
const lc = s => (s || '').toString().trim().toLowerCase()

function normalizeSession(profile) {
  return {
    // keep fields your app reads from localStorage
    email: lc(profile?.email || profile?.emailLower || ''),
    displayName: profile?.displayName || '',
    title: profile?.title || '',
    adminLevel: profile?.adminLevel || 'none',
    roles: Array.isArray(profile?.roles) ? profile.roles : [],
    communities: Array.isArray(profile?.communities) ? profile.communities : [],
    allCommunities: profile?.allCommunities === true,
    requirePasswordChange: !!profile?.requirePasswordChange,
    // maintain shape parity with previous code that stored claims
    claims: {},
  }
}

export async function signIn(email, password) {
  const em = lc(email)
  if (!em || !password) throw new Error('Company email and password are required.')

  // Authenticate against Firestore user record (salted hash)
  const user = await verifyFirestoreCredentials(em, password)

  // Ensure/refresh mirror at users/{emailLower} for rules/reads
  await ensureMirrorUserDocByEmailLower({ email: em, ...(user || {}) })

  if (user?.isActive === false || user?.status === 'archived') {
    throw new Error('This account is inactive or archived.')
  }

  const session = normalizeSession({ email: em, ...user })
  localStorage.setItem('session', JSON.stringify(session))
  notify()
  return session
}

export function getSession() {
  try { return JSON.parse(localStorage.getItem('session') || 'null') } catch { return null }
}

export async function signOut() {
  await firebaseSignOut(auth)
  localStorage.removeItem('session')
  notify()
}
